<template>
    <div v-if="isShow" :style="domStyle">
        <div style="width:100%;height:100%" v-html="svgInfo" ref="svgHtml">

        </div>
    </div>
</template>
<script>

export default {
    name : "",
    props : ["primitives","fvSystemApi","parentObject"],
    created(){
        //组件数据混淆
        this.mixin(this.primitives);
        //组件大小位置初始化
        this.domStyle = {
            position : "absolute",
            left : this.x + "px",
            top : this.y + "px",
            width : this.width + "px",
            height : this.height + "px"
        }
        this.enableStyle = {
            position: "absolute",
            width: "100%",
            height: "100%",
            top: "0px",
            backgroundColor: "#ccbfbf",
            opacity: "0.5"
        }
        this.monitor();
        this.modelsPath = this.parentObject.modelsPath.slice(0);
        this.modelsPath.push(this.registerName);
        this.$store.registerModule(this.modelsPath,{
            state : {
                $ : this
            }
        });

        // 获取svg文件地址
        this.loadSvgPath();

        // 获取数据
        this.getLoadData();
    },
    data(){
        return {
            //是否可用
            isEnable : false,
            //是否显示
            isShow : true,
            //组件大小位置,在created(创建完毕，挂载前)函数中初始化
            domStyle : {},
            currentWidth : "100%",
            currentHeight : "100%",
            svgInfo: "",
            varList: [],
            arrPvData: [],
            animatList: []
        }
    },
    computed: {
        currentUrl(){
            return this.pictureUrl;
        }
    },
    methods : {
        /*
            参数：src 原json数据
            作用：混淆数据到当前对象
        */
        mixin(src) {
            for (var key in src) {
                this[key] = src[key]
            }
        },
        /*
            参数：e 鼠标信息
                 domScale 窗口放大、缩小、偏移等信息
            作用：鼠标事件调用函数，无必要可不进行任何处理
        */
        doFixedEvent(e,domScale){},
        /*
            参数：无
            作用：系统周期调用
        */
        onTimer(){
            if(this.isEnable) return;
            this.getData();
            // this.system.getreal(this.mdfsdasdf[p]);
        },
        /*
            参数：无
            作用：所在窗口关闭时调用（vue生命周期函数销毁窗口之前调用）
        */
        onClose(){
            return new Promise((resolve)=>{
                resolve();
            })
        },
        /*
            参数：scaleObj 重绘信息
            作用：组件需要重绘时触发
        */
        reDraw(scaleObj){
            if(this.fontSize){
                this.$el.style.fontSize = parseInt(parseInt(this.fontSize.substr(0, this.fontSize.length - 2)) * (scaleObj.sy + scaleObj.zoom) + scaleObj.oy) + "px"; 
            }
            this.$el.style.left = parseInt((this.x * (scaleObj.sx + scaleObj.zoom)) + scaleObj.ox) + "px";
            this.$el.style.top  = parseInt((this.y * (scaleObj.sy + scaleObj.zoom)) + scaleObj.oy) + scaleObj.titleHeight + "px";
            this.$el.style.width = parseInt(this.width * (scaleObj.sx + scaleObj.zoom)) + "px";
            this.$el.style.height = parseInt(this.height * (scaleObj.sy + scaleObj.zoom)) + "px"; 
            this.currentWidth = parseInt(this.width * (scaleObj.sx + scaleObj.zoom)) + "px";
            this.currentHeight = parseInt(this.height * (scaleObj.sy + scaleObj.zoom)) + "px"; 
        },
        /*
            参数：isShow 显示隐藏
            作用：设置组件整体显隐
        */
        Show(isShow){
            this.isShow = isShow ? true : false;
        },
        /*
            参数：isEnable 是否可用
            作用：设置组件是否可用
        */
        Enable(isEnable){
            this.isEnable = isEnable ? false : true;
        },
        /*
            参数：无
            作用：更新svg图片展示
        */
        updateImg(value){
            this.currentUrl = value;
        },
        /*
            参数：无
            作用：监听组件内部属性
        */
        monitor(){
            // 内部属性 控制svg路径展示变化
            Object.defineProperty(this,"Path",{
                set(value){
                    this.currentUrl = value;
                    this.$forceUpdate();
                },
                get(){
                    return this.currentUrl;
                }
            })
        },
        // 读取文件信息
        loadSvgInfo(name) {
            let xhr = new XMLHttpRequest(),
                okStatus = document.location.protocol === "file:" ? 0 : 200;
            xhr.open('GET', name, false);
            xhr.overrideMimeType("text/html;charset=utf-8");//默认为utf-8
            xhr.send(null);
            return xhr.status === okStatus ? xhr.responseText : null;
        },
        loadSvgPath() {
            // 去除第一个斜杠
            this.pictureUrl = this.pictureUrl.split("/");
            this.pictureUrl.shift();
            this.pictureUrl = this.pictureUrl.join("/");

            let findIndex = window.location.href.indexOf("?");
            let href = window.location.href.slice(0, findIndex);


            this.svgInfo = this.loadSvgInfo(href + this.pictureUrl);
        },
        // 整合获取到的点名
        getLoadData() {
            this.varList = [];
            if(this.dbVar && this.dbVar.length > 0){
                this.dbVar.map((item) => {
                    let arrData = [];
                    arrData = item.split("\\");
                    let name = arrData[arrData.length - 1];
                    this.varList.push(name);
                });
            };
        },
        // 通过点获取实时数据
        getData(){
            if(this.varList && this.varList.length > 0){
                this.arrPvData = [];
                let results = Promise.all(this.varList.map(async(item) => {
                    var num = await this.fvSystemApi.getReal(item.PV);
                    this.arrPvData.push(num);
                    return true;
                }));
                results.then(() => {
                    this.svgAnalysis(this.$refs.svgHtml.children[0]);
                });
            };
        },
        /*
            功能：遍历svg文件节点
            参数：svg文件根节点
            返回值：无
        */
        svgAnalysis(dom) {
            for(let i = 0; i < dom.childNodes.length;i++){
                if(dom.childNodes[i].nodeType != 3){
                    this.svgCustomAttribute(dom.childNodes[i]);
                    if(dom.childNodes[i].childNodes){
                        this.svgAnalysis(dom.childNodes[i]);
                    }
                }  
            }
        },
        /*
            功能：解析svg文件
            参数：需要解析的节点
            返回值：无
        */
        svgCustomAttribute(dom){
            for(var i = 0; i < dom.attributes.length;i++){
                // 数据点解析
                let longPtName = this.piAnimation.output[dom.id];
                if(longPtName){
                    this.analysisPtData(longPtName, dom);
                };

                // 添加动画(闪烁)
                if(dom.nodeName == "pb:multistate"){
                    // 取動畫綁定的值
                    let getDataVal = async(ptName) => {
                        return await this.fvSystemApi.getReal(ptName.PV);
                    };
                    let twinkle = this.piAnimation.twinkle;
                    for (const key in twinkle) {
                        if (twinkle.hasOwnProperty(key)) {
                            let temp = twinkle[key];
                            if(temp[this._getDomId(dom)]){
                                getDataVal(temp[this._getDomId(dom)]).then((val) => {
                                    let arrData = temp['data'];
                                    if(arrData && arrData.length > 0){
                                        arrData.map((item) => {
                                            // 根據綁定的點填充對應的顔色
                                            if(val && val.PV){
                                                if(parseFloat(item.lowervalue) < val.PV < parseFloat(item.uppervalue)){
                                                    dom.parentNode.attributes.fill.nodeValue = item.color;
                                                }else{
                                                    dom.parentNode.attributes.fill.nodeValue = item.fill;
                                                };
                                            };
                                        });
                                    };
                                });
                            };

                        };
                    };
                };

                // 动画解析
                if(dom.attributes[i].name == "servername"){
                    this.analysisAnimat(this.piAnimation.twinkle[dom.id], dom);
                };

                // 按钮点击事件解析
                if(dom.attributes[i].name == "xlink:href"){
                    var svgName = dom.attributes[i].nodeValue;
                    dom.removeAttribute("xlink:href");
                    dom.style.cursor = "pointer";
                    dom.onclick = () => {
                        this.svgInfo = this.loadSvgInfo(window.location.href + "src/New App1/img/" + svgName);
                        


                        this.$nextTick(() => {
                            this.tagMappingMap = {};
                            this.dbVar = [];
                            this.piAnimation = {
                                output : {},
                                buttonClient : {},
                                twinkle : {}
                            };
                            // 解析新加载的svg
                            this.svgAnalysisDom(this.$refs.svgHtml.children[0]);
                            // 解析新加载的svg
                            this.getLoadData();
                        });

                        
                    };
                };
            };
        },
        // 动态给点赋值
        analysisPtData(tagName, dom) {
            if(this.arrPvData && this.arrPvData.length > 0){
                let data = this.arrPvData.find((item) => {
                    if(tagName.indexOf(item)){
                        return item;
                    };
                });
                dom.innerHTML = data ? (data.PV).toFixed(2) : 0;
            };
        },
        // 动画解析
        analysisAnimat(tagName, dom) {
            this.animatList.map((item) => { 
                if(tagName.name == dom.attributes.tagname.value){
                    dom.parentNode.attributes[1].value = tagName.color2;
                };
            });
        },
        // 解析新加载的svgdom
        svgAnalysisDom(dom) {
            for(let i = 0; i < dom.childNodes.length;i++){
                if(dom.childNodes[i].nodeType != 3){
                    this.svgCustomAttributeDom(dom.childNodes[i]);
                    if(dom.childNodes[i].childNodes){
                        this.svgAnalysisDom(dom.childNodes[i]);
                    }
                }  
            }
        },
        svgCustomAttributeDom(dom){
            for(var i = 0; i < dom.attributes.length;i++){
                if(dom.innerHTML == "No Data"){
                    var tagName = this._getTagName(dom.parentNode);
                    this.piAnimation.output[this._getDomId(dom)] = tagName;
                    
                    if(this.dbVar.length <= 0){
                        this.dbVar.push(tagName);
                    }else{
                        var isData = this.dbVar.find((item) => item == tagName);
                        if(!isData){
                            this.dbVar.push(tagName);
                        };
                    };
                };
                if(dom.attributes[i].name == "pbd:pttagname"){
                    var arr = dom.attributes[i].nodeValue.split("\\");
                    this.tagMappingMap[dom.attributes[i].nodeValue] = arr[3];
                };
                if(dom.attributes[i].name == "xlink:href"){
                    this.piAnimation.buttonClient[this._getDomId(dom)] = dom.attributes[i].nodeValue;
                };
                // 添加动画(闪烁)
                if(dom.nodeName == "pb:multistate"){
                    this.piAnimation.twinkle[this._getDomId(dom.parentElement)] = {};
                    let twinkle = this.piAnimation.twinkle[this._getDomId(dom.parentElement)]
                    // 添加点长名
                    twinkle[this._getDomId(dom)] = this._getTagName(dom);
                    // 解析结构里面的数据
                    let domList = dom.children;
                    if(domList && domList.length > 0){
                        
                        let arrData = [];
                        for (let j = 0; j < domList.length; j++) {
                            let jsonData = {};
                            jsonData[this._getDomId(domList[j])] = this._getDomId(domList[j]);
                            jsonData[this._getFill(dom.parentNode).name] = this._getFill(dom.parentNode).nodeValue;
                            jsonData[this._getFill(dom.parentNode).name] = this._getFill(dom.parentNode).nodeValue;
                            jsonData[this._getColor(domList[j]).name] = this._getColor(domList[j]).nodeValue;
                            jsonData[this._getLowerValue(domList[j]).name] = this._getLowerValue(domList[j]).nodeValue;
                            jsonData[this._getUpperCalue(domList[j]).name] = this._getUpperCalue(domList[j]).nodeValue;
                            arrData.push(jsonData);
                        };
                        twinkle['data'] = arrData;
                    };
                };
            };
        },
        // 查fill
        _getFill(dom) {
           for(var i = 0; i < dom.attributes.length;i++){
                if(dom.attributes[i].name == "fill"){
                    return dom.attributes[i];
                }
            }
        },
        // 最低值
        _getLowerValue(dom){
           for(var i = 0; i < dom.attributes.length;i++){
                if(dom.attributes[i].name == "lowervalue"){
                    return dom.attributes[i];
                }
            }
        },
        // 最高值
        _getUpperCalue(dom) {
            for(var i = 0; i < dom.attributes.length;i++){
                if(dom.attributes[i].name == "uppervalue"){
                    return dom.attributes[i];
                }
            }
        },
        // 取动画颜色
        _getColor(dom){
           for(var i = 0; i < dom.attributes.length;i++){
                if(dom.attributes[i].name == "color"){
                    return dom.attributes[i];
                }
            }
        },
        // 取id
        _getDomId(dom){
            for(var i = 0; i < dom.attributes.length;i++){
                if(dom.attributes[i].name == "id"){
                    return dom.attributes[i].nodeValue;
                }
            }
        },
        // 取tag
        _getTagName(dom){
            for(var i = 0; i < dom.attributes.length;i++){
                if(dom.attributes[i].name == "pbd:pttagname"){
                    return dom.attributes[i].nodeValue;
                }
            }
        }
    }
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/primitives/fvPiSvgPicture/fvPiSvgPicture.vue